import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import "./product_entry.css";
import ProductStepOne from "./product_step_one";
import ProductStepTwo from "./product_step_two";

import ProductStepFour from "./product_step_four";
import ProductStoreDetails from "./ProductStoreDetails";
import ProductExportDetails from "./productExportDetails";
import { ImageListItem, Paper } from "@mui/material";
import Table from "../../components/table/Table";

import "./product_entry.css";
import "../../components/modal/modal.css";
import { useDispatch, useSelector } from "react-redux";
import store from "../../redux/store";

import {
  addStepFour,
  uploadNewImages,
  addProduct,
  reset,
  fetchAllProduct,
  resetUploadState,
} from "../../redux/features/product.features";
import { showSuccess } from "../../redux/features/alertbox.features";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { fetchAllstorageBox } from "../../redux/features/storageBox.features";
import { fetchAllTitles } from "../../redux/features/titles.features";
import { useEffect } from "react";

const steps = [
  "Enter gem details",
  "Enter price details & Supplier",
  "Enter Store details",
  "Enter Export Packaging details",
  // "Choose customer",
  "Upload Images and Videos",
];

const FinalView = () => {
  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let {
    exportDetails,
    stepOne,
    stepTwo,
    stepThree,
    stepFour,
    loading,
    errorMessage,
    ItemStorage,
  } = productState;

  React.useEffect(() => {}, [stepOne, stepTwo, stepThree, stepFour]);
  const finalTableHead = [
    "title",
    "category",
    "description",
    "date",
    "clarity",
    "need_recut",
    "treatment_type",
    "origin",
    "shape",
    "weight",
    "dimension",

    "buyPrice",
    "sellPriceLocal",

    "buyPiece",
    "exchangeRate",
    "priceVariant",
    "sellPriceForeigners",
    "sellPriceForeigners2",
    "exportMainCategory",
    "exportWeightRange",
  ];

  const customerTableHead = [
    "firstName",
    "lastName",
    "homeAddress",
    "businessAddress",
    "mobile",
    "email",
    "country",
    "city",
    "status",
  ];
  const renderBody = (item, index) => {
    let selectedCustomerStore =
      store.getState().productReducer.stepThree.customer;
    return (
      <tr style={{ color: "var(--txt-color)" }} key={index}>
        {/* <td>{item.id}</td> */}
        <td>{item.firstName}</td>
        <td>{item.lastName}</td>
        <td>{item.homeAddress}</td>
        <td>{item.businessAddress}</td>
        <td>{item.mobile}</td>
        <td>{item.email}</td>
        <td>{item.country}</td>
        <td>{item.city}</td>
        <td>{item.status}</td>
      </tr>
    );
  };

  const finalRenderHead = (item, index) => (
    <th className="selected" key={index}>
      {item}
    </th>
  );

  const renderHead = (item, index) => (
    <th className="selected" key={index}>
      {item}
    </th>
  );

  const finalRenderBody = (item, index) => (
    <tr style={{ color: "var(--txt-color)" }} key={index}>
      {/* <td>{item.id}</td> */}
      <td>{item.title}</td>
      <td>{item.category}</td>
      <td>{item.description}</td>

      <td>{item.date}</td>
      <td>{item.clarity}</td>
      <td>{item.need_recut}</td>
      <td>{item.treatment_type}</td>
      <td>{item.origin}</td>
      <td>{item.shape}</td>
      <td>{item.weight}</td>
      <td>{item.dimension}</td>
      {/* <td>{item.buyCurrency}</td> */}
      <td>{item.buyPrice}</td>
      <td>{item.sellPriceLocal}</td>
      <td>{item.buyPiece}</td>
      <td>{item.exchangeRate}</td>
      <td>{item.priceVariant ? "On" : "Off"}</td>
      <td>{item.sellPriceForeigners}</td>

      <td>{item.sellPriceForeigners2}</td>
      <td>{item.exportMainCategory}</td>
      <td>{item.exportWeightRange}</td>
    </tr>
  );

  const finalData = () => {
    let dateSave = "";
    if (stepOne.date !== "") {
      dateSave = new Date(stepOne.date).toISOString().substring(0, 10);
    }

    console.log(dateSave);
    const customerTableHead = [
      {
        title: stepOne.title,
        description: stepOne.description,
        category: stepOne.category,
        date: dateSave,
        clarity: stepOne.clarity,
        need_recut: stepOne.need_recut,
        treatment_type: stepOne.treatment_type,
        origin: stepOne.origin,
        shape: stepOne.shape,
        weight: stepOne.weight,
        dimension:
          stepOne.dimensionHeight +
          "*" +
          stepOne.dimensionWidth +
          "*" +
          stepOne.dimensionDepth,

        buyCurrency: stepTwo.buyCurrency,
        buyPrice: stepTwo.buyPrice,
        sellPriceLocal: stepTwo.sellPriceLocal,
        sellLocalCurrency: stepTwo.sellLocalCurrency,
        sellForeignersCurrency: stepTwo.sellForeignersCurrency,

        sellPriceLocal2: stepTwo.sellPriceLocal2,

        sellPriceForeigners: stepTwo.sellPriceForeigners,
        sellPriceForeigners2: stepTwo.sellPriceForeigners2,
        priceVariant: stepTwo.priceVariant,
        buyPiece: stepTwo.buyPiece,
        exchangeRate: stepTwo?.exchangeRate,

        exportMainCategory: exportDetails?.exportMainCategory,
        exportWeightRange: exportDetails?.exportWeightRange,

        supplier: stepTwo?.supplier,
        supplierId: stepTwo?.supplierId,
        // customer: stepThree.customer,
        // images: stepFour.images,
        // videos: stepFour.videos,

        //storage
        // ItemStorage: ItemStorage,
        storageBoxName: ItemStorage.storageBoxName,
        storageSlot: ItemStorage.storageSlot,
      },
    ];

    console.log("data final data", customerTableHead);
    return customerTableHead;
  };

  return (
    <Box
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-between",
        padding: 20,
        bottom: 0,
        overflowY: "scroll",
        minHeight: 300,
      }}
      component="form"
      noValidate
      autoComplete="off"
    >
      <div className="row">
        <div style={{ marginBottom: 25 }} className="col-12">
          <Table
            limit="10"
            headData={finalTableHead}
            renderHead={(item, index) => finalRenderHead(item, index)}
            bodyData={finalData()}
            renderBody={(item, index) => finalRenderBody(item, index)}
          />
        </div>
        <div style={{ marginBottom: 25 }} className="col-12">
          <h5 style={{ color: "white", marginBottom: 15 }}>
            Selected Supplier
          </h5>
          <Table
            limit="10"
            headData={customerTableHead}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={store.getState().productReducer.stepTwo.supplier}
            renderBody={(item, index) => renderBody(item, index)}
          />
        </div>

        {/* <div style={{ marginBottom: 25 }} className="col-12">
          <h5 style={{ color: "white", marginBottom: 15 }}>
            Selected Customer
          </h5>
          <Table
            limit="10"
            headData={customerTableHead}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={store.getState().productReducer.stepThree.customer}
            renderBody={(item, index) => renderBody(item, index)}
          />
        </div> */}
        <div style={{ marginBottom: 25 }} className="row col-12">
          <div className="col-6">
            <h5 style={{ color: "white", marginBottom: 15 }}>Product Images</h5>
            <Box style={{ minHeight: 250 }} className="image-gallery col-12">
              {!loading &&
                stepFour.imagesUrl.length === 0 &&
                stepFour.images.map((imgSrc, i) => {
                  return (
                    <ImageListItem key={i} sx={{ margin: 2 }}>
                      <img
                        style={{ width: 100, height: 100 }}
                        className="image-gallery-img"
                        src={URL.createObjectURL(imgSrc)}
                        alt={"title"}
                        loading="lazy"
                      />
                      {i}
                    </ImageListItem>
                  );
                })}
              {loading && <h1>Uploading.....</h1>}
              {!loading && errorMessage && <h5>{errorMessage}</h5>}
              {stepFour.imagesUrl.length !== 0 &&
                stepFour.imagesUrl.map((imgSrc, i) => {
                  return (
                    <ImageListItem key={i} sx={{ margin: 2 }}>
                      <img
                        style={{ width: 100, height: 100 }}
                        className="image-gallery-img"
                        src={`${imgSrc}`}
                        alt={"title"}
                        loading="lazy"
                      />
                    </ImageListItem>
                  );
                })}
            </Box>
          </div>
          <div style={{ minHeight: 300 }} className="col-6">
            <h5 style={{ color: "white", marginBottom: 15 }}>Product Video</h5>
            <Box style={{ height: 350 }} className="image-gallery col-12">
              {stepFour.videos.map((videoSrc, i) => {
                return (
                  <ImageListItem key={i} sx={{ margin: 2 }}>
                    <video
                      style={{ width: "100%", height: 200 }}
                      controls
                      autoPlay
                      loop
                      muted
                    >
                      <source src={videoSrc} type="video/mp4"></source>
                    </video>
                  </ImageListItem>
                );
              })}
            </Box>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default function ProductStepper(props) {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [stepOneData, setstepOneData] = React.useState({});
  const [stepTwoData, setstepTwoData] = React.useState({});
  const [stepThreeData, setstepThreeData] = React.useState({});
  // const [stepThreeData, setstepThreeData] = React.useState({});

  useEffect(() => {
    dispatch(fetchAllstorageBox())
    dispatch(fetchAllTitles())
  }, [dispatch])
  

  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let {
    ItemStorage,
    stepOne,
    stepTwo,
    stepThree,
    stepFour,
    productAdded,
    exportDetails,
  } = productState;
  let { loading, uploading, errorMessage, successMessage } = productState;
  const [imgList, setImgList] = React.useState(stepThree.images || []);

  const isStepOptional = (step) => {
    return step === 0;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const Cancel = () => {
    if (window.confirm("Are you sure you want to Clear All")) {
      setActiveStep(0);
      dispatch(reset());
    }
  };
  const handleReset = () => {
    setActiveStep(0);
    dispatch(reset());
  };

  React.useEffect(() => {
    console.log("step one data", stepOneData);

    return () => {};
  }, [stepOneData, stepTwoData]);

  const saveAll = () => {
    console.log("save clicked");
    if (stepOne.date === "") return alert("Please select date");
    let dateSave = new Date(stepOne.date).toISOString().substring(0, 10);
    if (stepOne.title === "") return alert("Please select Title");
    if (stepTwo.sellPriceLocal === ("" || "0"))
      return alert("Please enter (sell Local) price");
    if (stepTwo.sellPriceForeigners === "")
      return alert("Please enter (sell Foreign) price");
    if (stepTwo.exchangeRate === "")
      return alert("Please enter (Exchange Rate) price");
    if (stepTwo.priceVariant) {
      if (stepTwo.sellPriceLocal2 === "")
        return alert("Price variant is on , Please enter (sell Local 2) price");
      if (stepTwo.sellPriceForeigners2 === "")
        return alert(
          "Price variant is on , Please enter (sell Foreign 2) price"
        );
    }

    if (ItemStorage.storageBoxName !== "") {
      if (ItemStorage.storageSlot === ("" || null))
        return alert("Please select a valid storage location");
    }

    const finalData = [
      {
        title: stepOne.title,
        description: stepOne.description,
        category: stepOne.category,

        date: dateSave,
        clarity: stepOne.clarity,
        need_recut: stepOne.need_recut,
        treatment_type: stepOne.treatment_type,
        origin: stepOne.origin,
        shape: stepOne.shape,
        weight: parseFloat(stepOne.weight).toFixed(2),

        dimensionHeight: stepOne.dimensionHeight,
        dimensionWidth: stepOne.dimensionWidth,
        dimensionDepth: stepOne.dimensionDepth,

        buyCurrency: stepTwo.buyCurrency,
        buyPrice: stepTwo.buyPrice,
        sellPriceLocal: stepTwo.sellPriceLocal,
        sellPriceLocal2: stepTwo.sellPriceLocal2,
        sellLocalCurrency: stepTwo.sellLocalCurrency,
        sellForeignersCurrency: stepTwo.sellForeignersCurrency,
        sellPriceForeigners: stepTwo.sellPriceForeigners,
        sellPriceForeigners2: stepTwo.sellPriceForeigners2,
        priceVariant: stepTwo.priceVariant,
        buyPiece: stepTwo.buyPiece,
        exchangeRate: stepTwo?.exchangeRate,

        exportMainCategory: exportDetails?.exportMainCategory,
        exportWeightRange: exportDetails?.exportWeightRange,

        supplier: stepTwo?.supplier,

        customer: stepThree.customer,
        images: stepFour.imagesUrl,
        videos: stepFour.videosUrl,

        //storage
        storageBoxName: ItemStorage.storageBoxName,
        storageSlot: ItemStorage.storageSlot,
      },
    ];

    console.log("added new product", finalData);

    dispatch(addProduct(finalData));
    setTimeout(() => {
      dispatch(fetchAllProduct());
    }, 1000);
  };

  React.useEffect(() => {
    if (productAdded) {
      // dispatch(showSuccess("product added successfully"));
    }
  }, [productAdded]);

  const onClickuploadImages = () => {
    // var confirm = prompt("Are you sure to upload this image or video")
    if (window.confirm("Are you sure you want to save this image or video ?")) {
      // Save it!
      console.log("Thing was saved to the database...uploading..");
      if (stepFour.images.length === 0)
        return alert("Please select least 1 image/video");
      stepFour.images.map((x) => {
        return dispatch(uploadNewImages(x));
      });
    } else {
      // Do nothing!
      console.log("Thing was not saved to the database.");
    }
  };

  React.useEffect(() => {}, [stepOne, stepTwo]);

  return (
    <>
      {uploading || successMessage !== "" || errorMessage !== "" ? (
        <LoadingScreen
          close={true}
          onClose={() => {
            //clear successMessage from state
            dispatch(resetUploadState());
            // handleReset();
          }}
          hideContinue
          loading={loading}
          uploading={uploading}
          errorMessage={errorMessage}
          successMessage={successMessage}
        />
      ) : (
        <div
          style={{ height: "80vh" }}
          className="flex flex-col justify-between p-5 items-center"
        >
          <Stepper
            style={{ height: "5vh", padding: 24 }}
            activeStep={activeStep}
          >
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              //   if (isStepOptional(index)) {
              //     labelProps.optional = (
              //       <Typography variant="caption">Optional</Typography>
              //     );
              //   }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>

          {activeStep === steps.length ? (
            // last step view
            <div style={{ width: "70vw" }} className="flex flex-col w-full ">
              <div>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>

                <Paper
                  style={{ backgroundColor: "var(--bg-dark)" }}
                  elevation={3}
                >
                  <FinalView />
                </Paper>
              </div>
              {/* bottom buttons */}
              <div className="items-center flex p-5 justify-evenly w-full bg-black">
                <Button
                  color="inherit"
                  // disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>

                <div className="flex w-full justify-end">
                  {stepFour.imagesUrl.length !== 0 ? (
                    <Button
                      onClick={productAdded ? handleReset : saveAll}
                      variant="contained"
                      color="success"
                      className="p-3"
                    >
                      {productAdded ? "Refresh" : "Save"}
                    </Button>
                  ) : stepFour.images.length !== 0 ? (
                    <Button
                      onClick={() => handleReset}
                      variant="contained"
                      color="warning"
                      className="p-3"
                    >
                      {"Refresh"}
                    </Button>
                  ) : (
                    <Button
                      onClick={productAdded ? handleReset : saveAll}
                      variant="contained"
                      color="success"
                      className="p-3"
                    >
                      {productAdded ? "Refresh" : "Save All Now"}
                    </Button>
                  )}
                </div>
              </div>
              <div className="p-3 flex justify-between items-center"></div>
            </div>
          ) : (
            <div
              style={{ width: "70vw" }}
              className="flex flex-col w-full  items-center "
            >
              {/* content */}
              <div className=" flex flex-col w-full justify-center ">
                {activeStep === 0 ? (
                  <ProductStepOne setStepOneData={setstepOneData} />
                ) : null}
                {activeStep === 1 ? (
                  <ProductStepTwo setStepTwo={setstepTwoData} />
                ) : null}
                {activeStep === 2 ? <ProductStoreDetails /> : null}
                {activeStep === 3 ? <ProductExportDetails /> : null}
                {/* {activeStep === 4 ? <ProductStepThree /> : null} */}
                {activeStep === 4 ? <ProductStepFour /> : null}
              </div>

              {/* bottom buttons */}
              <div className="items-center flex p-5 justify-evenly w-full bg-black">
                <Button
                  color="inherit"
                  // disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
                <Button color="inherit" onClick={() => Cancel()} sx={{ mr: 1 }}>
                  Cancel
                </Button>

                <div className="flex w-full justify-between">
                  <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                    Skip
                  </Button>

                  <div
                    className="flex w-full justify-between"
                    style={{ width: "250px" }}
                  >
                    {(
                      (activeStep === steps.length - 1 &&
                        stepFour.images &&
                        stepFour.imagesUrl.length !== stepFour.images.length) ||
                      []
                    ).length !== 0 ? (
                      <Button onClick={() => onClickuploadImages()}>
                        Upload Image / Video
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    )}

                    <Button
                      variant="contained"
                      onClick={productAdded ? handleReset : saveAll}
                      color="success"
                      className="p-3"
                    >
                      {productAdded ? "Refresh" : "Save Immediate"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
